'use client';

import { Check, X } from 'lucide-react';
import { useTranslation } from '@/i18n/useTranslation';

const FEED_ITEMS = [
  'landing_beyond_feed.feeds_item_1',
  'landing_beyond_feed.feeds_item_2',
  'landing_beyond_feed.feeds_item_3',
  'landing_beyond_feed.feeds_item_4',
] as const;

const RECORD_ITEMS = [
  'landing_beyond_feed.record_item_1',
  'landing_beyond_feed.record_item_2',
  'landing_beyond_feed.record_item_3',
  'landing_beyond_feed.record_item_4',
  'landing_beyond_feed.record_item_5',
] as const;

export default function BeyondFeedSection() {
  const { t } = useTranslation();
  return (
    <section className="bg-white py-20 sm:py-24">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.22em] text-emerald-800">
            Some moments pass. Their meaning should not.
          </p>
          <h2 className="font-serif text-3xl leading-tight text-slate-950 sm:text-4xl">
            A book that continues as life continues
          </h2>
        </div>

        <div className="mx-auto mt-12 grid gap-5 sm:grid-cols-2">
          <div className="rounded-[14px] border border-slate-200 bg-slate-50/70 p-6">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.08em] text-slate-500">
              {t('landing_beyond_feed.feeds_label' as any)}
            </p>
            <ul className="space-y-3">
              {FEED_ITEMS.map((key) => (
                <li key={key} className="flex items-start gap-2.5 text-sm text-slate-600">
                  <X size={15} className="mt-0.5 shrink-0 text-slate-400" aria-hidden="true" />
                  {t(key as any)}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-[14px] border border-emerald-800/20 bg-emerald-50/50 p-6">
            <p className="mb-4 text-sm font-bold uppercase tracking-[0.08em] text-emerald-900">
              {t('landing_beyond_feed.record_label' as any)}
            </p>
            <ul className="space-y-3">
              {RECORD_ITEMS.map((key) => (
                <li key={key} className="flex items-start gap-2.5 text-sm text-slate-700">
                  <Check
                    size={15}
                    className="mt-0.5 shrink-0 text-emerald-700"
                    aria-hidden="true"
                  />
                  {t(key as any)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
